import React, { useRef, useState, useEffect } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

/* =======================
   Premium Newsletter Card
======================= */
const ReportImageCard = ({ image, title, file }) => {
  return (
    <div
      className="relative flex-shrink-0 
      w-[300px] md:w-[360px] lg:w-[400px] h-[420px] 
      rounded-2xl overflow-hidden 
      bg-white 
      shadow-[0_20px_50px_rgba(0,0,0,0.08)] 
      group transition-all duration-500 
      hover:-translate-y-2 
      hover:shadow-[0_30px_70px_rgba(0,0,0,0.12)]"
    >
      <img
        src={image}
        alt={title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
      />

      {/* Hover Info Only */}
      <div
        className="absolute inset-0 
        bg-black/60 opacity-0 
        group-hover:opacity-100 
        transition duration-500 
        flex flex-col items-center justify-center text-center p-8"
      >
        <h3 className="text-white text-xl font-semibold mb-4">
          {title}
        </h3>

        <a
          href={file}
          download
          className="px-6 py-3 bg-white text-gray-900 
          rounded-full font-medium 
          hover:bg-gray-100 transition"
        >
          View Newsletter →
        </a>
      </div>
    </div>
  );
};

/* =======================
   Enterprise Scroller
======================= */
const HorizontalScroller = ({ items = [] }) => {
  const containerRef = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(true);

  const updateButtons = () => {
    const el = containerRef.current;
    setCanLeft(el.scrollLeft > 0);
    setCanRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 5);
  };

  useEffect(() => {
    updateButtons();
  }, []);

  const scroll = (dir) => {
    const width = containerRef.current.offsetWidth;
    containerRef.current.scrollBy({
      left: dir === "left" ? -width : width,
      behavior: "smooth",
    });
  };

  return (
    <div className="relative w-full py-16 bg-[#f9fafb]">
      {/* Left Arrow */}
      <button
        onClick={() => scroll("left")}
        disabled={!canLeft}
        className={`absolute left-4 top-1/2 -translate-y-1/2 z-10 
        bg-white shadow-lg rounded-full p-3 transition
        ${!canLeft ? "opacity-40 cursor-not-allowed" : "hover:scale-110"}`}
      >
        <ChevronLeft size={22} />
      </button>

      {/* Right Arrow */}
      <button
        onClick={() => scroll("right")}
        disabled={!canRight}
        className={`absolute right-4 top-1/2 -translate-y-1/2 z-10 
        bg-white shadow-lg rounded-full p-3 transition
        ${!canRight ? "opacity-40 cursor-not-allowed" : "hover:scale-110"}`}
      >
        <ChevronRight size={22} />
      </button>

      {/* Scroller */}
      <div
        ref={containerRef}
        onScroll={updateButtons}
        className="flex gap-10 overflow-x-scroll no-scrollbar px-16 scroll-smooth"
      >
        {items.map((item, i) => (
          <ReportImageCard key={i} {...item} />
        ))}
      </div>
    </div>
  );
};

export default HorizontalScroller;
